import settings, { YearFormat } from '../services/settings'
import { toFaDigits } from './digits'

// The Shahanshahi (imperial) calendar is the Jalaali one with another epoch:
// same months, same day counts, the year counted from Cyrus's accession in
// 559 BC — 1180 years ahead of the Jalaali year.
const SHAHANSHAHI_OFFSET = 1180

// A Jalaali year written the way the user asked for it in settings, in Persian
// digits. Every place that prints a solar year goes through this, so the month
// header, the day page and the occasion page always agree. The format can be
// named outright — the settings sheet does, to label each choice with itself.
export const solarYear = (jy: number, format: YearFormat = settings.get().yearFormat) => {
    if (format === 'jalaali') return toFaDigits(jy)
    const shahanshahi = toFaDigits(jy + SHAHANSHAHI_OFFSET)
    return format === 'shahanshahi' ? shahanshahi : `${shahanshahi} (${toFaDigits(jy)})`
}

// A finished date line with its bracketed Jalaali years dimmed, so the
// Shahanshahi year leads and the Jalaali one sits behind it. Dimming happens
// here at render time rather than inside solarYear, because the same lines also
// go out as plain text — notification bodies, .text() labels — where markup
// would show up literally. Set the result with .html().
// A range counts as one bracket too: the years view writes a whole block as
// ۲۵۸۰ – ۲۶۲۹ (۱۴۰۰ – ۱۴۴۹), and both of its Jalaali years belong behind the
// Shahanshahi ones. Only a year or a pair of years is matched, so an ordinary
// bracket elsewhere in a date line is still left alone.
export const paleYear = (line: string) =>
    line.replace(/\([\d۰-۹]+(?:\s*[–-]\s*[\d۰-۹]+)?\)/g, '<span style="opacity:.35">$&</span>')
